import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40b994d4")

_pushScopeId("data-v-40b994d4")
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Emergency Contacts", -1)
const _hoisted_3 = { style: {"display":"flex","width":"100%","align-items":"end"} }
const _hoisted_4 = { class: "buttons-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Save")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_form, {
        "element-loading-text": "Saving...",
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "status-icon": "",
        "label-position": "top"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, { label: "Emergency Contact Instructions" }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.emergency_contact_instructions,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.emergency_contact_instructions = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_2,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contactCount, (n) => {
            return (_openBlock(), _createBlock("div", null, [
              (_ctx.form.contacts[n - 1].id)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    type: "hidden",
                    modelValue: _ctx.form.contacts[n - 1].id,
                    "onUpdate:modelValue": ($event: any) => (_ctx.form.contacts[n - 1].id = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_el_form_item, { label: "Name" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.contacts[n - 1].name,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.contacts[n - 1].name = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, {
                  label: "Phone number",
                  style: {"margin-left":"0.5rem"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.contacts[n - 1].phone,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.contacts[n - 1].phone = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, { style: {"margin-left":"0.5rem"} }, {
                  default: _withId(() => [
                    _createVNode("button", {
                      type: "button",
                      class: "el-button",
                      onClick: ($event: any) => ($setup.removeContact(n))
                    }, "Remove", 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          }), 256)),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("button", {
                type: "button",
                class: "el-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.contactCount++))
              }, "Add Contact")
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: $setup.saveOrgGroup
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.saveState === $setup.FetchStates.FETCHING]
      ])
    ])
  ]))
})